<template>
  <div id="app">
    <keep-alive :include="keepAliveArr">
      <router-view  />
    </keep-alive>
    <page-footer v-if="!isMobile"></page-footer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'App',
  computed: {
    ...mapState(['indexStore']),
    keepAliveArr () {
      return this.indexStore.keepAliveArr
    }
  },
  data: function () {
    return {
      isMobile: false
    }
  },

  mounted () {
    // 如果是移动端就进行这里
    if (
      this.browser.versions.mobile ||
        this.browser.versions.ios ||
        this.browser.versions.android ||
        this.browser.versions.iPhone ||
        this.browser.versions.iPad
    ) {
      this.isMobile = true
    }
    if (!Array.prototype.filter) {
    // eslint-disable-next-line no-extend-native
      Array.prototype.filter = function (func, thisArg) {
        'use strict'
        // eslint-disable-next-line valid-typeof
        if (!((typeof func === 'Function' || typeof func === 'function') && this)) { throw new TypeError() }

        // eslint-disable-next-line one-var
        var len = this.length >>> 0, res = new Array(len), t = this, c = 0, i = -1
        if (thisArg === undefined) {
          while (++i !== len) {
            // checks to see if the key was set
            if (i in this) {
              if (func(t[i], i, t)) {
                res[c++] = t[i]
              }
            }
          }
        } else {
          while (++i !== len) {
            // checks to see if the key was set
            if (i in this) {
              if (func.call(thisArg, t[i], i, t)) {
                res[c++] = t[i]
              }
            }
          }
        }

        res.length = c // shrink down array to proper size
        return res
      }
    }
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue